import React, { useState, Fragment, useEffect } from "react";
import styles from "./SupActivity.module.css";
import {
  Alert,
  Card,
  Col,
  Divider,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import {
  CloudDownloadOutlined,
  SearchOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { ChartCard } from "ant-design-pro/lib/Charts";
import { fetchTrend, fetchUserVal } from "../../../../api";
import { arrComparer } from "../../../../api/util";
import "chartjs-plugin-datalabels";
import { CSVLink } from "react-csv";
const { Text } = Typography;
const { Option } = Select;
const { Search } = Input;

const fetchSupAct = async (rel) => {
  const data = await fetchUserVal("fetSupAct", {
    firstVal: rel,
  });
  return data;
};

const fetchUserSearch = async (usrRel, app, diff) => {
  try {
    const prevRel = parseInt(usrRel.split("snapshot_v")[1].split("_")[0]) - 1;
    const data = await fetchUserVal("fetSupMod", {
      firstVal: usrRel,
      secondVal: usrRel,
      thirdVal: usrRel,
      fourthVal: app,
    });

    if (diff <= 1) {
      const prevRelData = await fetchUserVal("fetSupMod", {
        firstVal: "snapshot_v" + prevRel + "_0_0",
        secondVal: "snapshot_v" + prevRel + "_0_0",
        thirdVal: "snapshot_v" + prevRel + "_0_0",
        fourthVal: app,
      });

      const addedApps = data["data"].filter(arrComparer(prevRelData["data"]));
      const remApps = prevRelData["data"].filter(arrComparer(data["data"]));
      data["data"].map((d) => {
        d["actChange"] = "";
      });
      addedApps.map((x) => {
        data["data"].map((y) => {
          if (x["current_name"] === y["current_name"]) {
            y["actChange"] = "Added";
          }
        });
      });

      remApps.map((z) => {
        z["actChange"] = "Removed";
        data["data"].push(z);
      });
    }

    return data;
  } catch (error) {
    return [];
  }
};

const SupActivity = () => {
  const [rel, setRel] = useState(null);
  const [usrRel, setUsrRel] = useState("");
  const [load, setLoad] = useState(true);
  const [submit, setSubmit] = useState(true);

  useEffect(() => {
    if (!rel) {
      fetchData();
    }
  }, [rel]);

  const fetchData = async () => {
    setLoad(true);
    const relVersion = await fetchTrend("fetConVersion");
    setRel(relVersion["curVersion"]);
    setUsrRel("snapshot_v" + relVersion["curVersion"] + "_0_0");
    setLoad(false);
  };

  function onChange(value) {
    message.info(`Release snapshot_v${value}_0_0`);
    setUsrRel("snapshot_v" + value + "_0_0");
    setSubmit(!submit);
  }

  return (
    <div>
      {/* date range filter */}
      <Row type="flex" style={{ margin: "5px", padding: "1px" }}>
        <Col className="gutter-row" span={1}></Col>
        <Col className="gutter-row" span={14}>
          <Card
            bordered={false}
            style={{ height: 70, margin: "1px", padding: "1px" }}
          >
            <Tooltip title="Release Search">
              <Space>
                {load ? (
                  <div>
                    <Spin size="small" />
                  </div>
                ) : (
                  <Select
                    showSearch
                    // defaultValue={usrRel}
                    style={{ width: 400 }}
                    placeholder="Select Release"
                    optionFilterProp="children"
                    onChange={onChange}
                  >
                    <Option value={rel}>Release {rel}</Option>
                    <Option value={rel - 1}>Release {rel - 1}</Option>
                    <Option value={rel - 2}>Release {rel - 2}</Option>
                    <Option value={rel - 3}>Release {rel - 3}</Option>
                    <Option value={rel - 4}>Release {rel - 4}</Option>
                  </Select>
                )}
              </Space>
            </Tooltip>
          </Card>
        </Col>
      </Row>

      {/* Card */}
      <Row style={{ margin: "5px", padding: "1px" }}>
        {load ? (
          <div className={styles.spinner}>
            <Spin size="small" />
          </div>
        ) : (
          <FetchTabSearch submit={submit} rel={rel} usrRel={usrRel} />
        )}
      </Row>
    </div>
  );
};

// Modal Popup Window
const OpenMod = (props) => {
  const [app, setApp] = useState(props.app);
  const [searchVal, setSearchVal] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [searchIndex, setSearchIndex] = useState([]);
  const [loading, setLoading] = useState(true);
  const [chngData, setChngData] = useState({
    stat: true,
    display: "",
    remData: [],
    addData: [],
  });
  const diff =
    parseInt(props.rel) -
    parseInt(props.usrRel.split("snapshot_v")[1].split("_")[0]);

  useEffect(() => {
    setLoading(true);
    const crawl = (user, allValues) => {
      if (!allValues) allValues = [];
      for (var key in user) {
        if (typeof user[key] === "object") crawl(user[key], allValues);
        else allValues.push(user[key] + " ");
      }
      return allValues;
    };
    const fetchDatas = async () => {
      const { data: users } = await fetchUserSearch(
        props.usrRel,
        props.app,
        diff
      );
      setOrigData(users);
      setFilteredData(users);
      const searchInd = users.map((user) => {
        const allValues = crawl(user);
        return { allValues: allValues.toString() };
      });
      setSearchIndex(searchInd);
      if (users) setLoading(false);
    };
    if (props.openModal === true) {
      fetchDatas();
    }
  }, [props.trig]);

  useEffect(() => {
    if (searchVal) {
      const reqData = searchIndex.map((user, index) => {
        if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0)
          return origData[index];
        return null;
      });
      setFilteredData(
        reqData.filter((user) => {
          if (user) return true;
          return false;
        })
      );
    } else setFilteredData(origData);
  }, [searchVal, origData, searchIndex, props.app]);

  const [show, setShow] = useState(false);
  const openModal = () => setShow(props.openModal);
  const closeModal = () => {
    setSearchVal("");
    setChngData({ stat: true, display: "", remdata: [], addData: [] });
    setShow(false);
  };

  useEffect(() => {
    setApp(props.app);
    if (props.openModal === true) {
      openModal();
    }
  }, [props.trig]);

  const ColOwn = [
    {
      title: () => {
        return (
          <>
            Application Name{" "}
            <Tag color="processing">
              {filteredData.length -
                filteredData.filter((x) => x["actChange"] == "Removed").length}
            </Tag>
          </>
        );
      },
      dataIndex: "current_name",
      key: "current_name",
      fixed: "left",
      width: "40%",
      sorter: (a, b) =>
        a.current_name ? a.current_name.localeCompare(b.current_name) : 1,
    },
  ];

  return (
    <Modal
      title={
        loading ? (
          <div>
            <Spin size="small" />
          </div>
        ) : (
          <Text keyboard>
            <>{app}</>
          </Text>
        )
      }
      visible={show}
      onOk={closeModal}
      confirmLoading={loading}
      onCancel={closeModal}
      width={"35%"}
    >
      {diff <= 1 ? (
        <ChartCard
          title={
            <Row style={{ padding: "1px" }}>
              <Col span={12}>
                <Text type="secondary"> Changes in - {props.usrRel}</Text>
              </Col>
            </Row>
          }
          bordered={false}
        >
          {loading ? (
            <Spin size="small"></Spin>
          ) : (
            <Tag
              color="success"
              icon={<CheckCircleOutlined />}
              style={{ fontSize: "11px", padding: "1px" }}
              onClick={() => {
                let data = [];
                filteredData
                  .filter((a) => a["actChange"] == "Added")
                  .map((x) => {
                    data.push(x["current_name"]);
                  });
                data.length <= 0
                  ? console.log("")
                  : setChngData({
                      stat: false,
                      display: "add",
                      addData: data.sort().join(", "),
                      remData: chngData["remdata"],
                    });
              }}
            >
              Apps started supporting {props.app} {"- "}
              {filteredData.filter((a) => a["actChange"] == "Added").length}
            </Tag>
          )}

          {loading ? (
            <></>
          ) : (
            <Tag
              icon={<CloseCircleOutlined />}
              style={{ fontSize: "11px", padding: "1px" }}
              color="error"
              onClick={() => {
                let data = [];
                filteredData
                  .filter((a) => a["actChange"] == "Removed")
                  .map((x) => {
                    data.push(x["current_name"]);
                  });
                data.length <= 0
                  ? console.log("")
                  : setChngData({
                      stat: false,
                      display: "removed",
                      addData: chngData["addData"],
                      remData: data.sort().join(", "),
                    });
              }}
            >
              Apps stopped supporting {props.app} {"- "}
              {filteredData.filter((a) => a["actChange"] == "Removed").length}
            </Tag>
          )}
          <div style={{ padding: "2px" }}></div>
          <Fragment>
            {!chngData["stat"] && !loading ? (
              <Alert
                message={
                  chngData["display"] !== "add"
                    ? chngData["remData"]
                    : chngData["addData"]
                }
                type={chngData["display"] !== "add" ? "error" : "success"}
                closable
                onClose={() => {
                  setChngData({
                    stat: true,
                    display: "",
                    remdata: chngData["remData"],
                    addData: chngData["addData"],
                  });
                }}
              />
            ) : null}
          </Fragment>
        </ChartCard>
      ) : (
        ""
      )}

      <Card
        className={styles.chart}
        size="small"
        headStyle={{ backgroundColor: "#F0F8FF", border: 2 }}
        extra={
          <Row>
            <Col span={21}>
              <Input
                value={searchVal}
                onChange={(e) => {
                  setSearchVal(e.target.value);
                }}
                prefix={<SearchOutlined className="site-form-item-icon" />}
                placeholder="Crawl Search"
                allowClear
              />
            </Col>
            <Col span={1}></Col>
            <Col className="gutter-row" span={2}>
              {" "}
              <div>
                {loading ? (
                  <div>
                    <Spin size="small" />
                  </div>
                ) : (
                  <Tooltip
                    placement="topRight"
                    title={"Download " + props.app + " Report"}
                    arrowPointAtCenter
                  >
                    <CSVLink
                      filename={props.usrRel + "_" + props.app + ".csv"}
                      data={filteredData}
                      className="btn btn-primary"
                    >
                      <CloudDownloadOutlined style={{ fontSize: "29px" }} />
                    </CSVLink>
                  </Tooltip>
                )}
              </div>
            </Col>
          </Row>
        }
        bordered={true}
        loading={loading}
      >
        <Fragment>
          <Table
            rowKey="application_id"
            size="small"
            bordered
            scroll={{ x: 550, y: 900 }}
            style={{ margin: "2px" }}
            dataSource={filteredData.filter(
              (x) => x["actChange"] !== "Removed"
            )}
            columns={ColOwn}
            loading={loading}
            pagination={{
              pageSizeOptions: ["10", "30", "60", "100", "1000"],
              showSizeChanger: true,
            }}
          />
        </Fragment>
      </Card>
    </Modal>
  );
};

const FetchTabSearch = (props) => {
  const [searchVal, setSearchVal] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [searchIndex, setSearchIndex] = useState([]);
  const [loading, setLoading] = useState(true);
  const [app, setApp] = useState("");
  const [trig, setTrig] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const ColOwn = [
    {
      title: () => {
        return (
          <>
            Activity Name{" "}
            {loading ? (
              <div>
                <Spin size="small" />
              </div>
            ) : (
              <Tag color="processing">{filteredData.length}</Tag>
            )}
          </>
        );
      },
      dataIndex: "activity_name",
      key: "activity_name",
      fixed: "left",
      width: "40%",
      sorter: (a, b) =>
        a.activity_name ? a.activity_name.localeCompare(b.activity_name) : 1,
      render: (text, record) => (
        <Space size="middle">
          <a
            onClick={() => {
              setApp(record.activity_name);
              setOpenModal(true);
              setTrig(!trig);
              // openModal();
            }}
          >
            {record.activity_name}
          </a>
        </Space>
      ),
    },
    {
      title: () => {
        return (
          <>
            Priority{" "}
            {loading ? (
              <div>
                <Spin size="small" />
              </div>
            ) : (
              <>
                <Tag color="processing">
                  {"P1: " +
                    filteredData.filter((it) => it.notes === "P1").length}
                </Tag>
                <Tag color="processing">
                  {"P2: " +
                    filteredData.filter((it) => it.notes === "P2").length}
                </Tag>
              </>
            )}
          </>
        );
      },
      dataIndex: "notes",
      key: "notes",
      defaultSortOrder: "ascend",
      sorter: (a, b) => (a.notes ? a.notes.localeCompare(b.notes) : 1),
      fixed: "left",
      width: "15%",
    },
    {
      title: "App",
      dataIndex: "app",
      key: "app",
      sorter: (a, b) => a.app - b.app,
      fixed: "left",
      width: "15%",
    },
    {
      title: "Web",
      dataIndex: "web",
      key: "web",
      sorter: (a, b) => a.web - b.web,
      fixed: "left",
      width: "15%",
    },
  ];

  useEffect(() => {
    setLoading(true);
    const crawl = (user, allValues) => {
      if (!allValues) allValues = [];
      for (var key in user) {
        if (typeof user[key] === "object") crawl(user[key], allValues);
        else allValues.push(user[key] + " ");
      }
      return allValues;
    };
    const fetchData = async () => {
      const { data: users } = await fetchSupAct(props.usrRel);
      setOrigData(users);
      setFilteredData(users);
      const searchInd = users.map((user) => {
        const allValues = crawl(user);
        return { allValues: allValues.toString() };
      });
      setSearchIndex(searchInd);
      if (users) setLoading(false);
    };
    fetchData();
  }, [props.submit]);

  useEffect(() => {
    if (searchVal) {
      const reqData = searchIndex.map((user, index) => {
        if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0)
          return origData[index];
        return null;
      });
      setFilteredData(
        reqData.filter((user) => {
          if (user) return true;
          return false;
        })
      );
    } else setFilteredData(origData);
  }, [searchVal, origData, searchIndex, props.submit]);

  return (
    <>
      <div>
        <Row gutter={16}>
          <Col className="gutter-row" span={1}></Col>
          <Col span={22}>
            <Card
              title={
                "Release - " + props.usrRel.split("snapshot_v")[1].split("_")[0]
              }
              size="small"
              headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
              extra={
                <Row>
                  <Col span={21}>
                    <Input
                      onChange={(e) => setSearchVal(e.target.value)}
                      prefix={
                        <SearchOutlined className="site-form-item-icon" />
                      }
                      placeholder="Crawl Search"
                      allowClear
                    />
                  </Col>
                  <Col span={1}></Col>
                  <Col className="gutter-row" span={2}>
                    {" "}
                    <div>
                      {loading ? (
                        <div>{/* <Spin size="small" /> */}</div>
                      ) : (
                        <Tooltip
                          placement="topRight"
                          title={"Download activity_report_" + props.usrRel}
                          arrowPointAtCenter
                          // color={"#CCD1D1"}
                          // key={"#2db7f5"}
                        >
                          <CSVLink
                            filename={
                              "activity_report_" + props.usrRel + ".csv"
                            }
                            data={filteredData}
                            className="btn btn-primary"
                          >
                            <CloudDownloadOutlined
                              style={{ fontSize: "29px" }}
                            />
                          </CSVLink>
                        </Tooltip>
                      )}
                    </div>
                  </Col>
                </Row>
              }
            >
              <Fragment>
                <Table
                  rowKey="activity_id"
                  size="small"
                  bordered
                  scroll={{ x: 550, y: 900 }}
                  style={{ margin: "2px" }}
                  dataSource={filteredData}
                  columns={ColOwn}
                  loading={loading}
                  pagination={{
                    pageSizeOptions: ["10", "30", "60", "100", "1000"],
                    defaultPageSize: "50",
                    showSizeChanger: true,
                  }}
                />
              </Fragment>
              <Fragment>
                <OpenMod
                  usrRel={props.usrRel}
                  rel={props.rel}
                  app={app}
                  openModal={openModal}
                  trig={trig}
                />
              </Fragment>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SupActivity;
